// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__uBWS_","Section":"Form_Section__HFYWV","Title":"Form_Title__2zmBS","Button":"Form_Button__2Uk82","SubmitError":"Form_SubmitError__1llYA"};